import { toCamelCaseProperties } from '@/utils/fn';

export default class WebshopBrand {
	constructor(args) {
		args = toCamelCaseProperties(args) || {};

		this.id = args.id || 0;
		this.count = args.count || 0;
		this.title = args.name || '';
		this.children = args.series ? args.series.map(child => new WebshopBrand(child)) : [];
	}
}
